export default __webpack_public_path__ + "static/media/thanks_message_credit_card.1ce7e018.png";